<app-modal-base
  [title]="'scanQrCode' | translate"
  [showCloseIcon]="false"
  [primaryButtonText]="'done' | translate"
  [showSecondaryButton]="false"
  (primaryClick)="dialogRef.close(true)"
>
  <!-- QR Code -->
  <div class="flex justify-center mb-4">
    <app-qr-code-handler-component
      [qrOptions]="{
        qrData: wallet?.cryptoAddress?.address || '',
        ariaLabel: 'Nicky Scan QR-code',
        alt: 'Nicky Scan QR-code',
      }"
      [errorLabel]="'PAYMENT_REPORT.sorryQrCodeGenerationIsUnavailable'"
      id="scan-qr-code"
    ></app-qr-code-handler-component>
  </div>

  <!-- Address Label -->
  <div class="text-sm text-gray-800 mb-2">
    <h2 class="font-medium text-left">
      <span [innerHTML]="getAddressViaNetwork()"> </span>
      <i
        class="ph ph-info text-gray-400 ml-1 text-left tooltip-icon"
        matTooltip="{{ getWrongNetworkInforming() }}"
        matTooltipPosition="below"
        toggleMatTooltip
      ></i>
    </h2>
    <p class="text-sm mt-1 break-words text-left text-black font-bold break-all">
      {{ wallet?.cryptoAddress?.address }}
    </p>
  </div>

  <!-- Wallet Info -->
  <p class="text-xs text-[#929292] mb-4 text-left">
    {{ getWalletExchange(true) }}
  </p>
</app-modal-base>
